

/// <reference path="SalesAnnotation.ts" />

// Generated class SalesModifierAnnotation_ManagedObject

class SalesModifierAnnotation_ManagedObject extends SalesAnnotation
{
}
